import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

// Platform branding + toggles. Fetched once at app boot from GET /api/platform
// (public endpoint — no auth required). Consumers should not fall back to
// literal "LeadFlow" strings; use `platform.name` etc.
const DEFAULTS = {
  name: "LeadFlow",
  short_name: "LeadFlow",
  tagline: "Web Lead Operations",
  domain: "leadflow.io",
  show_public_status_page: false,
  status_page_headline: "",
  status_page_subhead: "",
  support_email: "",
  // Iter-53: Number-visibility toggles. Both default OFF so nothing
  // changes for existing installs. Read on every admin surface that
  // renders a phone / cost / price.
  hide_phone_displays_global: false,
  hide_admin_numbers_global: false,
};

const PlatformContext = createContext(DEFAULTS);

export function PlatformProvider({ children }) {
  const [platform, setPlatform] = useState(DEFAULTS);
  const refresh = () => api.get("/platform")
    .then((r) => setPlatform({ ...DEFAULTS, ...r.data }))
    .catch(() => setPlatform(DEFAULTS));
  useEffect(() => { refresh(); }, []);
  return (
    <PlatformContext.Provider value={{ ...platform, refresh }}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform() {
  return useContext(PlatformContext);
}
